import { useParams } from 'react-router-dom'
import { useMountpointInfo } from 'api'
import { MountpointInfoForm } from './MountpointInfoForm'
// import { useMap, MapContextProps } from 'MapProvider'
import Card from 'common/Card'
import { strings } from 'strings'

export function MountpointInfo() {
  const { mid } = useParams<any>()
  const { mountpointInfo, loading, error } = useMountpointInfo(mid)

  // const { map } = useMap() as MapContextProps

  let content

  if (loading) content = <div>Loading</div>
  else if (error) content = <div>{error.message}</div>
  else if (mountpointInfo) {
    content = <MountpointInfoForm mountpointInfo={mountpointInfo} />
    // map?.flyTo({
    //   center: [mountpointInfo.longitude, mountpointInfo.latitude],
    //   essential: true,
    //   zoom: 15,
    // })
  }

  return (
    <Card title={strings.stationSettigns} style={{ overflow: 'auto', paddingBottom: 0 }}>
      {content}
    </Card>
  )
}
